import * as React from 'react';
import Form from 'src/components/controls/forms/Form';
import IOwner from 'src/models/IOwner';
import AddressUtil from 'src/util/Address';
import FormCheckbox from 'src/components/controls/forms/redesign/FormCheckbox';
import { FieldArray } from 'react-final-form-arrays';
import FormRow from 'src/components/controls/forms/FormRow';
import * as _ from 'lodash';
import { FormApi } from 'final-form';
import SearchResult from 'src/models/OwnerSearchResult';
import { AnyObject } from 'react-final-form';
import { FormErrors } from 'src/util/FormErrors';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { ManageDeviationsPage } from './ManageDeviationsDialog';
import OwnerUtil from 'src/util/OwnerUtil';

export interface IOwnerChangePrimaryDialogProps {
    changePrimaryFormCreated: (form: FormApi) => void;
    changePrimary: (owner: IOwner) => void;
    clearTargetDeviations: () => void;
    changePage: (page: ManageDeviationsPage) => void;
}

export type IOwnerChangePrimaryStateProps = {
    ownerDeviations: Array<IOwner>;
    searchResults?: Array<SearchResult>;
    form: FormApi;
    page: ManageDeviationsPage;
};

type IOwnerChangePrimaryState = {
    hasUncheckedDeviations: boolean;
    searchString: string;
    searchOwnerType: string;
};

type IOwnerChangePrimaryDialogPageProps = IOwnerChangePrimaryDialogProps & IOwnerChangePrimaryStateProps;

class OwnerChangePrimary extends React.Component<IOwnerChangePrimaryDialogPageProps, IOwnerChangePrimaryState> {
    constructor(props: IOwnerChangePrimaryDialogPageProps) {
        super(props);
        this.state = {
            hasUncheckedDeviations: false,
            searchString: undefined,
            searchOwnerType: undefined,
        };
    }

    ownerName = (owner: IOwner) => {
        let name = undefined;
        if (owner) {
            const mappedOwner = OwnerUtil.MapOwner(owner);
            name = mappedOwner ? mappedOwner.ownerName() : 'N/A';
        }
        return name;
    };

    submitPrimary = (values: AnyObject) => {
        const ownerDeviations = values.ownerDetails as IOwner[];
        const newPrimary = ownerDeviations.find((x) => x.isPrimaryDeviation);
        this.props.changePrimary(newPrimary);
        this.props.changePage(ManageDeviationsPage.Menu);
    };

    validate = (values: AnyObject) => {
        const errors: AnyObject = {};
        if (values && values.ownerDetails) {
            if (!values.ownerDetails.some((x: AnyObject) => _.get(x, 'isPrimaryDeviation') === true)) {
                this.setState({ hasUncheckedDeviations: true });
            } else {
                this.setState({ hasUncheckedDeviations: false });
            }
        }

        return errors as FormErrors<AnyObject>;
    };

    selectPrimarySecondaryDeviationOwner = (index: number) => {
        const valuesClone = _.cloneDeep(this.props.form?.getState().values as AnyObject);
        if (!valuesClone?.ownerDetails) {
            return;
        }
        const owners = valuesClone.ownerDetails;
        for (let i = 0; i < owners.length; ++i) {
            const tempOwner = owners[i];
            if (tempOwner === undefined) {
                continue;
            }
            if (i !== index) {
                tempOwner.isPrimaryDeviation = false;
            }
            this.props.form?.mutators.update('ownerDetails', i, tempOwner);
        }
        this.setState(this.state);
    };

    ownerPrimarySecondaryDeviations = () => {
        return (
            <>
                {this.state.hasUncheckedDeviations && (
                    <div style={{ background: '#ffc4c4', borderWidth: 'thin', borderStyle: 'solid', borderColor: 'red' }}>
                        Please select a new primary
                    </div>
                )}
                <FieldArray name="ownerDetails">
                    {({ fields, meta }) =>
                        fields.map((name, index) => (
                            <div key={name}>
                                <div>
                                    <FormRow>
                                        <div style={{ width: '1rem' }}>
                                            <FormCheckbox
                                                label=""
                                                name={`${name}.isPrimaryDeviation`}
                                                onChange={() => this.selectPrimarySecondaryDeviationOwner(index)}
                                            />
                                        </div>
                                        <div>
                                            <FormRow>
                                                <div className="change-owner-detail-card-name">
                                                    <label>
                                                        <span>{this.ownerName(this.props.ownerDeviations[index])}</span>
                                                    </label>
                                                </div>
                                            </FormRow>
                                            <FormRow>
                                                <div className="change-owner-detail-card-address">
                                                    {' '}
                                                    {this.props.ownerDeviations[index].address?.addressLine1}{' '}
                                                </div>
                                                <div className="change-owner-detail-card-address">
                                                    {/* tslint:disable-next-line:max-line-length */}
                                                    {AddressUtil.concatWithCommas(
                                                        this.props.ownerDeviations[index].address?.city,
                                                        this.props.ownerDeviations[index].address?.state?.name,
                                                        this.props.ownerDeviations[index].address?.zipCode
                                                    )}
                                                </div>
                                            </FormRow>
                                        </div>
                                    </FormRow>
                                </div>
                            </div>
                        ))
                    }
                </FieldArray>
            </>
        );
    };
    prevPage = () => {
        this.props.changePage(ManageDeviationsPage.Menu);
        this.props.clearTargetDeviations();
    };

    public render() {
        return (
            <Form
                onSubmit={this.submitPrimary}
                initialValues={{ ownerDetails: this.props.ownerDeviations ? this.props.ownerDeviations : [] }}
                hasFieldArray={true}
                validate={this.validate}
                showDebugValues={true}
                onFormCreated={this.props.changePrimaryFormCreated}
            >
                <div>
                    {this.props.page === ManageDeviationsPage.ChangePrimary && (
                        <div style={{ width: '100rem' }}>
                            <div style={{ overflow: 'auto', height: '40rem' }}>{this.ownerPrimarySecondaryDeviations()}</div>
                            <div className="mt-3">
                                <Button text="Prev" onClick={() => this.prevPage()} />
                                <Button className="ml-1" type="submit" text="Make Primary" intent="primary" />
                            </div>
                        </div>
                    )}
                </div>
            </Form>
        );
    }
}

export default OwnerChangePrimary;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/OwnerChangePrimary.tsx